<template>
    <div class="sections">
        <div class="section1">
           <Navbar/> 
        </div>
        <div class="section2">
            <router-view/>
        </div>
        <div class="section3"><Footer/></div>
        <div class="section4">
            <SideNav/>
        </div>
    </div>
</template>
<script>
    import Navbar from '../shared/Navbar.vue';
    import Footer from '../shared/Footer.vue';
    import SideNav from '../shared/SideNav.vue';
    export default{
        components:{
            Navbar,Footer,SideNav
        }
    }
</script>
<style scoped>
   
    .sections{
        display: grid;
        grid-template-rows:auto 1fr auto;
        grid-template-columns: auto 1fr;
        min-height: 100vh;
    }
    .section1, .section3{
        background-color: var(--primary);
    }

    .section1{
        grid-column:2/3;
        grid-row:1/2; 
    }
    .section2{
        grid-column: 2/3;
        grid-row:2/3;
       padding:4.4rem 0.7rem;
    }
    .section3{
        grid-column:1/3;
        grid-row:3/4;
    }

    .section4{
        grid-column: 1/2;
        grid-row: 1/3;
        display: grid;
    }
</style>